import {PropsWithChildren, useEffect, useRef, useState} from "react";
import {createPortal} from "react-dom";

interface IRenderInWindowProps {
    onClose?: () => void;
    height?: number,
    width?: number,
}

const RenderInNewWindow = (props: IRenderInWindowProps & PropsWithChildren) => {
    const [container, setContainer] = useState<HTMLElement>();
    const newWindow = useRef<any>(null);

    function copyStyles(src: any, dest: any) {
        Array.from(src.styleSheets).forEach((styleSheet: any) => {
            const styleElement = styleSheet.ownerNode.cloneNode(true);
            styleElement.href = styleSheet.href;
            dest.head.appendChild(styleElement);
        });
        try {
            Array.from(src.fonts).forEach((font) => dest.fonts.add(font));
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        // Create container element on client-side
        setContainer(document.createElement("div"));
    }, []);

    useEffect(() => {
        // When container is ready
         if (container) {
            // Create window
            newWindow.current = window.open(
                "",
                "",
                `popup,height=${props.height || window.screen.height}, width=${props.width || window.screen.width}`,
            );
            // Append container
            container.style.width = "100%";
            container.style.height = "100%";
            container.style.display = "flex";
            newWindow.current.document.body.appendChild(container);
            copyStyles(window.document, newWindow.current.document);
            // Save reference to window for cleanup
            const curWindow = newWindow.current;
            curWindow.onbeforeunload = () => {
                props.onClose && props.onClose()
            }
            // Return cleanup function
            return () => {
                props.onClose && props.onClose()
                curWindow.close()
            };
        }
        return () => {

        };
    }, [container]);

    return container && createPortal(props.children, container);
};

export default RenderInNewWindow;